class ReportConfig extends BaseItemConfig {
    static readonly reportIdOfCustomDisplayGroupByName: number = -1
    static readonly reportIdOfNoneOrCustomDisplayAnalyzeByName: number = 0

    isOriginalTemplate: boolean;

    get isReportConfig() { return true };

    reportType: KnockoutObservable<ReportTypeEnum>;
    enableSearchBox: KnockoutObservable<boolean>;
    enableRowSelection: KnockoutObservable<boolean>;
    totalsPosition: KnockoutObservable<TotalsPositionEnum>;
    subtotalsPosition: KnockoutObservable<TotalsPositionEnum>;
    grandTotalText: KnockoutObservable<string>;
    subTotalText: KnockoutObservable<string>;
    showReportRowCount: KnockoutObservable<boolean>;
    columnsWidthType: KnockoutObservable<ColumnsWidthTypeEnum>;
    includeAllMetrics: KnockoutObservable<boolean>;
    columnResizingMode: KnockoutObservable<ColumnResizingModeEnum>;
    glReport: KnockoutObservable<boolean>;
    expandAllRows: KnockoutObservable<boolean>;
    expandAllRowsPrinting: KnockoutObservable<boolean>;
    fontSize: KnockoutObservable<number>;
    filterZeros: KnockoutObservable<boolean>;
    keepMetricsDrillDown: KnockoutObservable<boolean>;
    enableFilterPanel: KnockoutObservable<boolean>;
    numberFixedColumns: KnockoutObservable<number>;
    chartDefinition: ChartDefinition;
    isAggregative: KnockoutObservable<boolean>;
    pivotConfig: PivotConfig;
    pivotLayout: KnockoutObservable<PivotLayoutEnum>;
    topBottom: KnockoutObservable<TopBottomEnum>;
    resultCount: KnockoutObservable<number>;
    topBottomFieldName: KnockoutObservable<any>;
    topBottomGroupBy: KnockoutObservable<TopBottomEnum>;
    resultCountGroupBy: KnockoutObservable<number>;
    topBottomGroupByFieldName: KnockoutObservable<any>;
    columnNamesAlign: KnockoutObservable<any>;
    comparisonFilters: KnockoutObservableArray<ComparisonFilter>;
    groupReportId: KnockoutObservable<any>;
    templateId: KnockoutObservable<any>;
    orderFields: KnockoutObservableArray<ReportField | MetricField>;
    source: KnockoutObservable<any>;
    visibility: KnockoutObservable<VisibilityEnum>;
    analyzeByName: KnockoutComputed<string>;
    customAnalyzeByName: KnockoutObservable<string>;
    customDisplayAnalyzeByName: KnockoutComputed<string>;
    groupByName: KnockoutComputed<string>;
    customGroupByName: KnockoutObservable<string>;
    customDisplayGroupByName: KnockoutComputed<string>;

    fields: KnockoutObservableArray<ReportField>;
    groupReportFields: KnockoutObservableArray<GroupingFields>;
    metricFields: KnockoutObservableArray<MetricField>;

    get allowDetailTab() { return true; }
    get hasGroupBy() {
        return this.groupReportId() > 0 || (this.groupReportFields()?.length > 0 && this.groupReportFields()[0].fields().length > 0);
    }

    //ResultsPerPage
    //TotalsLock

    constructor(data: any, isOriginalTemplate: boolean = false) {
        if (!data.$type) {
            data.$type = "irng.Display.ReportConfig, irng.Data";
        }
        super(data);

        this.isOriginalTemplate = isOriginalTemplate;
        this.reportType = ko.observable(data.reportType);
        this.enableSearchBox = ko.observable(data.enableSearchBox);
        this.enableRowSelection = ko.observable(data.enableRowSelection);
        this.totalsPosition = ko.observable(data.totalsPosition);
        this.subtotalsPosition = ko.observable(data.subtotalsPosition);
        this.grandTotalText = ko.observable(data.grandTotalText);
        this.subTotalText = ko.observable(data.subTotalText);
        this.showReportRowCount = ko.observable(data.showReportRowCount);
        this.columnsWidthType = ko.observable(data.columnsWidthType);
        this.includeAllMetrics = ko.observable(data.includeAllMetrics);
        this.columnResizingMode = ko.observable(data.columnResizingMode);
        this.glReport = ko.observable(data.glReport ?? false);
        this.expandAllRows = ko.observable(data.expandAllRows);
        this.expandAllRowsPrinting = ko.observable(data.expandAllRowsPrinting);
        this.fontSize = ko.observable(data.fontSize);
        this.filterZeros = ko.observable(data.filterZeros);
        this.keepMetricsDrillDown = ko.observable(data.keepMetricsDrillDown);
        this.enableFilterPanel = ko.observable(data.enableFilterPanel);
        this.numberFixedColumns = ko.observable(data.numberFixedColumns);
        this.isAggregative = ko.observable(data.isAggregative);
        this.pivotConfig = new PivotConfig(data.pivotConfig);
        this.pivotLayout = ko.observable(data.pivotLayout);
        this.columnNamesAlign = ko.observable(data.columnNamesAlign);
        
        this.fields = ko.observableArray();
        this.groupReportFields = ko.observableArray();
        this.metricFields = ko.observableArray();
        this.updateFieldsGroupsMetrics(data);
        this.orderFields = ko.observableArray();
        this.updateOrderFields(data);
        this.topBottom = ko.observable(TopBottomEnum.All);
        this.resultCount = ko.observable(10);
        this.topBottomFieldName = ko.observable();
        this.topBottomGroupBy = ko.observable(TopBottomEnum.All);
        this.resultCountGroupBy = ko.observable(10);
        this.topBottomGroupByFieldName = ko.observable();
        this.updateTopBottom(data);

        this.chartDefinition = new ChartDefinition(data.chartDefinition);

        this.comparisonFilters = ko.observableArray(createInstances(ComparisonFilter, data?.comparisonFilters ?? []));
        this.groupReportId = ko.observable(data.groupReportId);
        this.templateId = ko.observable(data.templateId < 0 ? 0 : data.templateId);

        this.source = ko.observable(data.source);
        this.visibility = ko.observable(data.visibility);        
        this.customAnalyzeByName = ko.observable(data.customAnalyzeByName);
        this.customDisplayAnalyzeByName = ko.computed(function (this: ReportConfig) {
            let name = this.customAnalyzeByName();
            if (!this.customAnalyzeByName() && this.templateId() == 0)
            {
                var reportField = this.fields().find(x => !x.isMetric && x.visible()) ?? this.fields().find(x => !x.isMetric);
                if (reportField?.fieldDisplayName != null) {
                    name = reportField.fieldDisplayName; //Asked by Charles to show only the field name
                    //return `${reportField.fieldDisplayTableName} ${reportField.fieldDisplayName}`;
                }
            }

            name = replaceBasicHtmlContent(name);
            return name;
        }, this);
        this.analyzeByName = ko.computed(function (this: ReportConfig) {
            let name = "";
            if (this.templateId() === ReportConfig.reportIdOfNoneOrCustomDisplayAnalyzeByName) {
                name = this.customDisplayAnalyzeByName();
            }
            else {
                let template = this.reportTemplateListForAnalyzeBy.find(x => x.id === this.templateId());
                if (template) {
                    name = replaceBasicHtmlContent(template.name);
                }
            }

            return name;
        }, this);
        this.customGroupByName = ko.observable(data.customGroupByName);
        this.customDisplayGroupByName = ko.computed(function (this: ReportConfig) {
            let name = this.customGroupByName();
            if (!this.customGroupByName() && this.groupReportId() <= 0 && this.groupReportFields().length > 0) {
                var reportField = this.groupReportFields()[0].fields().find(x => !x.isMetric && x.visible()) ?? this.groupReportFields()[0].fields().find(x => !x.isMetric);
                if (reportField?.fieldDisplayTableName != null) {
                    name = `${reportField.fieldDisplayTableName} ${reportField.fieldDisplayName}`;
                }
            }

            name = replaceBasicHtmlContent(name);
            return name;
        }, this);
        this.groupByName = ko.computed(function (this: ReportConfig) {
            let name = "";
            if (this.groupReportId() === ReportConfig.reportIdOfCustomDisplayGroupByName) {
                name = this.customDisplayGroupByName();
            }
            else if (this.groupReportId() !== 0) {
                let template = this.reportTemplateListForAnalyzeBy.find(x => x.id === this.groupReportId());
                if (template) {
                    name = replaceBasicHtmlContent(template.name);
                }
            }

            return name;
        }, this);
    }

    override saveAnalyzeByOrGroupBy(tabOrWidget: ITabOrWidget, drilldown: Drilldown, isSaveGroupBy = false, isDrilldown?: boolean, newDrilldownTabName: string = null) {
        this.saveChangeAnalyzeByOrGroupBy(tabOrWidget, this.templateId(), this.groupReportId(), isSaveGroupBy, isDrilldown, newDrilldownTabName);
    }

    validateOrderFields() {
        let self = this;

        if (self.orderFields().length > 0) {
            let deletedFields: Array<ReportField> = [];
            for (let field of self.orderFields()) {
                if (field.isMetric && self.reportType() !== ReportTypeEnum.Analysis) {
                    if (!self.metricFields().find(x => x.queryName === field.queryName)) {
                        deletedFields.push(field);
                    }
                }
                else {
                    if (!self.fields().find(x => x.isMetric == field.isMetric && x.queryName === field.queryName)) {
                        deletedFields.push(field);
                    }
                }
            }
            for (let deletedField of deletedFields) {
                self.orderFields.remove(deletedField);
            }
        }

        if (self.topBottom() != TopBottomEnum.All) {
            let removeTopBottom = false;
            if (self.reportType() !== ReportTypeEnum.Analysis) {
                if (!self.metricFields().find(x => x.queryName === self.topBottomFieldName())) {
                    removeTopBottom = true;
                }
            }
            else {
                if (!self.fields().find(x => x.isMetric && x.queryName === self.topBottomFieldName())) {
                    removeTopBottom = true
                }
            }
            if (removeTopBottom) {
                self.topBottom(TopBottomEnum.All);
                self.topBottomFieldName(null);
            }
        }
    }

    private _reportTemplateListAnalyzeBy: Array<Drilldown>;
    get reportTemplateListForAnalyzeBy() {
        if (!this._reportTemplateListAnalyzeBy) {
            this._reportTemplateListAnalyzeBy = createInstances(Drilldown, workbook.workbookConfig.reportTemplateList?.() ?? []);
            this._reportTemplateListAnalyzeBy.unshift(new Drilldown({
                id: ReportConfig.reportIdOfNoneOrCustomDisplayAnalyzeByName,
                name: this.customDisplayAnalyzeByName,
                isAggregative: true,
                order: 1,
                mappingTemplate: false,
                source: "",
                visible: ko.computed(function (this: ReportConfig) {
                    return this.templateId() === 0;
                }, this)
            }));
        }

        return this._reportTemplateListAnalyzeBy;
    }

    private _reportTemplateListGroupBy: Array<Drilldown>;
    get reportTemplateListForGroupBy() {
        if (!this._reportTemplateListGroupBy) {
            this._reportTemplateListGroupBy = createInstances(Drilldown, workbook.workbookConfig.reportTemplateList?.() ?? []);
            this._reportTemplateListGroupBy.unshift(new Drilldown({
                id: ReportConfig.reportIdOfNoneOrCustomDisplayAnalyzeByName,
                name: "None",
                isAggregative: true,
                order: 1,
                mappingTemplate: false,
                source: "",
                visible: ko.computed(function (this: ReportConfig) {
                    return this.reportType() !== ReportTypeEnum.Pivot;
                }, this),
            }));
            this._reportTemplateListGroupBy.unshift(new Drilldown({
                id: ReportConfig.reportIdOfCustomDisplayGroupByName,
                name: this.customDisplayGroupByName,
                isAggregative: true,
                order: 1,
                mappingTemplate: false,
                source: "",
                visible: ko.computed(function (this: ReportConfig) {
                    return this.groupReportId() === -1;
                }, this)
            }));
        }
        return this._reportTemplateListGroupBy;
    }

    saveTopBottom(tabOrWidget: ITabOrWidget, element, oldValues) {
        let self = this;
        let submitObject = tabOrWidget.getBaseSubmitObject();
        submitObject.resultCount = this.resultCount();
        submitObject.topBottom = this.topBottom();
        submitObject.orderField = this.topBottomFieldName();
        submitObject.resultCountGroupBy = this.resultCountGroupBy();
        submitObject.topBottomGroupBy = this.topBottomGroupBy();
        submitObject.orderFieldGroupBy = this.topBottomGroupByFieldName();

        let o = {
            url: urlConfigs.workBook + "ChangeTopBottom",
            data: submitObject,
            dataType: "json",
            async: true,
        } as RequestServerParams;
        o.successFunction = function (data, e) {
            DevExpress.ui.notify(`Top/Bottom changed.`);
            if (!tabOrWidget.drilldownManager.isDrilldown) {
                tabOrWidget.refresh();
            }
            else {
                tabOrWidget.drilldownManager.refresh();
            }
        };
        o.failureFunction = function (textStatus, failureText, errorItem: IError) {
            errorItem.userMessage = `Failed to change Top/Bottom`;
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, failureText);

            //Go back to the old values
            self.topBottom(oldValues.topBottom);
            self.topBottomFieldName(oldValues.topBottomFieldName);
            self.resultCount(oldValues.resultCount);
            self.topBottomGroupBy(oldValues.topBottomGroupBy);
            self.topBottomGroupByFieldName(oldValues.topBottomGroupByFieldName);
            self.resultCountGroupBy(oldValues.resultCountGroupBy);
        };

        irGlobal.requestServer(o);
    }

    changeReportType(tabOrWidget: ITabOrWidget, widgetType: WidgetType) {
        let self = this;
        let submitObject = tabOrWidget.getBaseSubmitObject();
        submitObject.drilldownId = tabOrWidget.drilldownManager.activeDrilldownId;
        submitObject.reportType = widgetTypeToReportType(widgetType);

        let o = {
            url: urlConfigs.workBook + "ChangeConfig",
            data: submitObject,
            dataType: "json",
            async: true,
        } as RequestServerParams;
        o.successFunction = function (data, e) {
            DevExpress.ui.notify(`Report type changed.`);

            workbook.workbookConfig.isChangingTabOrWidget(true);

            tabOrWidget.drilldownManager.getActiveWidget().disposeSettingsSubscriptions();

            self.updateReportAfterSaving(data);

            self.reportType(submitObject.reportType);
            if (!tabOrWidget.drilldownManager.isDrilldown) {
                tabOrWidget.widgetType(widgetType);
                if (tabOrWidget.tabOrWidget === TabOrWidgetEnum.Tab) {
                    let tabType = widgetTypeToTabType(widgetType);
                    (tabOrWidget as WorkbookTab).tabType(tabType);
                }
            }

            let dashboardWidget = tabOrWidget.tabOrWidget === TabOrWidgetEnum.Widget ? tabOrWidget as DashboardWidget : null;
            let reportWidget = BaseWidget.createWidget(null, workbook.workbookConfig.activeTab(), dashboardWidget, widgetType);
            reportWidget.itemConfig = self;
            tabOrWidget.drilldownManager.getActiveWidget().disposeSettingsSubscriptions();
            tabOrWidget.drilldownManager.updateCurrentWidget(reportWidget);
            reportWidget.setupSettings();

            workbook.workbookConfig.isChangingTabOrWidget(false);

            tabOrWidget.drilldownManager.refresh();
            IntroService.refreshIntroHints();
        };
        o.failureFunction = function (textStatus, failureText, errorItem: IError) {
            errorItem.userMessage = `Failed to change the report type`;
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, failureText);
        };

        irGlobal.requestServer(o);
    }

    switchAnalyzeByAndGroupBy(tabOrWidget: ITabOrWidget, callback: Function) {
        let self = this;
        let submitObject = tabOrWidget.getBaseSubmitObject();
        submitObject.drilldownId = tabOrWidget.drilldownManager.activeDrilldownId;

        let o = {
            url: urlConfigs.workBook + "SwitchAnalyzeByAndGroupBy",
            data: submitObject,
            dataType: "json",
            async: true,
        } as RequestServerParams;
        o.successFunction = function (data, e) {
            DevExpress.ui.notify(`Report type changed.`);

            workbook.workbookConfig.isChangingTabOrWidget(true);

            self.updateReportAfterSaving(data);
            
            workbook.workbookConfig.isChangingTabOrWidget(false);

            callback();

            self.updateDrilldownListRemovingTemplateId(tabOrWidget, () => {
                tabOrWidget.drilldownManager.refresh();
            });
        };
        o.failureFunction = function (textStatus, failureText, errorItem: IError) {
            errorItem.userMessage = `Failed to change the report type`;
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, failureText);
        };

        irGlobal.requestServer(o);
    }

    override updateDrilldownListRemovingTemplateId(tabOrWidget: ITabOrWidget, callback: Function = null) {
        let newDrilldownList = tabOrWidget.drilldownManager.drilldownList().slice(1).filter(x => x.id !== this.templateId());

        newDrilldownList = newDrilldownList.filter(
            (item, index, self) => index === self.findIndex((obj) => obj.id === item.id)
        );//Remove duplicates

        if (tabOrWidget.drilldownManager.activeReportConfig) {
            const reportConfig = tabOrWidget.drilldownManager.activeReportConfig;
            const drilldown = tabOrWidget.drilldownManager.getActiveDrilldown();
            const drilldownCopy = newDrilldownList.find(x => x.id === drilldown.id);
            if (drilldownCopy) {
                drilldownCopy.id = reportConfig.templateId();
                drilldownCopy.isAggregative = reportConfig.isAggregative();
                drilldownCopy.mappingTemplate = true;
                drilldownCopy.name = tabOrWidget.drilldownManager.reportTemplateListForDrilldown().find(x => x.id === drilldown.id)?.name || drilldown.name;
            }
        }

        //Update the current drilldown to disable it in drilldown list
        const updateCurrentDrilldown = () => {
            if (tabOrWidget.drilldownManager.activeReportConfig) {
                const reportConfig = tabOrWidget.drilldownManager.activeReportConfig;
                const drilldown = tabOrWidget.drilldownManager.getActiveDrilldown();
                drilldown.id = reportConfig.templateId();
                drilldown.isAggregative = reportConfig.isAggregative();
                drilldown.mappingTemplate = true;
                drilldown.name = tabOrWidget.drilldownManager.reportTemplateListForDrilldown().find(x => x.id === drilldown.id)?.name || drilldown.name;
            }

            if (callback) {
                callback();
            }
        }

        if (newDrilldownList.length !== tabOrWidget.drilldownManager.drilldownList().length) {
            let firstIndexChanged = tabOrWidget.drilldownManager.isDrilldown ? tabOrWidget.drilldownManager.activeDrilldownIndex() : 0;
            tabOrWidget.drilldownManager.updateDrilldownList(newDrilldownList, firstIndexChanged, () => {
                updateCurrentDrilldown();
            }, false);
        }
        else {
            updateCurrentDrilldown();
        }
        
    }

    override updateReportAfterSaving(data) {
        this.updateFieldsGroupsMetrics(data);
        this.updateOrderFields(data);
        this.includeAllMetrics(data.includeAllMetrics);
        this.updateTopBottom(data);

        this.isAggregative(data.isAggregative);
        //When the report is not aggregative, it can't have comparison filters
        if (this.isAggregative()) {
            this.comparisonFilters(createInstances(ComparisonFilter, data.comparisonFilters ?? []));
        }
        else {
            this.comparisonFilters.removeAll();
        }
        this.customAnalyzeByName(data.customAnalyzeByName);
        this.customGroupByName(data.customGroupByName);
        this.templateId(data.templateId);
        this.groupReportId(data.groupReportId);
    }

    updateFieldsGroupsMetrics(data: any) {

        let fields = [];
        if (data.fields) {
            for (let field of data.fields) {
                fields.push(ReportField.createReportOrMetricField(field, this.isOriginalTemplate));
            }
        }
        this.fields(fields);

        if (data.groupReportFields && data.groupReportFields.length > 0) {
            this.groupReportFields(createInstancesWithParameter(GroupingFields, data.groupReportFields, this.isOriginalTemplate));
        }
        else {
            this.groupReportFields([new GroupingFields()]);
        }

        this.metricFields(createInstancesWithParameter(MetricField, data.metricFields, this.isOriginalTemplate));

        let metrics = [...this.metricFields(), ...this.fields().filter(x => x.isMetric).map(x => x as MetricField)];
        for (let metricField of metrics.filter(x => x.metricContainer.comparisonType === ComparisonMetricType.None)) {
            let children = metrics.filter(x => x.metricContainer.parentQueryName === metricField.queryName);
            for (let child of children) {
                child.parentMetricField = metricField;
            }
        }
    }

    private updateTopBottom(data) {
        this.topBottom(data.topBottom === 0 ? TopBottomEnum.All : data.topBottom);
        this.resultCount(data.resultCount === 0 ? 10 : data.resultCount);
        this.topBottomFieldName(data.topBottomFieldName);
        this.topBottomGroupBy(data.topBottomGroupBy === 0 ? TopBottomEnum.All : data.topBottomGroupBy);
        this.resultCountGroupBy(data.resultCountGroupBy === 0 ? 10 : data.resultCountGroupBy);
        this.topBottomGroupByFieldName(data.topBottomGroupByFieldName);
    }

    private updateOrderFields(data) {
        let orderFields = [];
        if (data.orderFields) {
            for (let field of data.orderFields) {
                orderFields.push(ReportField.createReportOrMetricField(field, this.isOriginalTemplate));
            }
        }
        this.orderFields(orderFields);
    }

    updateAfterReportDesigner(reportConfig: ReportConfig) {
        this.fields(reportConfig.fields());
        this.groupReportFields(reportConfig.groupReportFields());
        this.metricFields(reportConfig.metricFields());

        this.comparisonFilters(reportConfig.comparisonFilters());
        this.includeAllMetrics(reportConfig.includeAllMetrics());
        this.customAnalyzeByName(reportConfig.customAnalyzeByName());
        this.customGroupByName(reportConfig.customGroupByName());
        this.templateId(reportConfig.templateId());
        this.groupReportId(reportConfig.groupReportId());
    }

    saveColumnOrdering(orderFields: Array<{ fieldName: string, order: Order, orderIndex: number }>, callback: () => void = null) {
        let tabOrWidget = workbook.workbookConfig.activeTabOrWidget();
        let model = tabOrWidget.getBaseSubmitObject() as any;
        model.orderFields = orderFields;
        if (tabOrWidget.drilldownManager.isDrilldown) {
            model.drilldownId = tabOrWidget.drilldownManager.activeDrilldownId;
        }

        let o = {
            url: urlConfigs.workBook + "ChangeOrder",
            data: model,
            dataType: "json",
            async: true
        } as RequestServerParams;
        o.successFunction = function () {
            if (callback) {
                callback();
            }
        }
        o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
            errorItem.userMessage = `Failed to save column order`;
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
        };
        irGlobal.requestServer(o);
    }

    getPivotColumnsSeparator() {
        let mapping = MappingService.getCurrentMapping();

        if (this.reportType() === ReportTypeEnum.Pivot &&
            (this.pivotConfig.columnFieldsText() === ColumnFieldsTextPivotEnum.LineBreak ||
            (this.pivotConfig.columnFieldsText() === ColumnFieldsTextPivotEnum.Automatic && ((this.includeAllMetrics() && mapping.visibleMetrics.length < 2) || this.metricFields().length < 2)))) {

            return "<br />";
        }

        return irSettings.columnSeparatorForHtml;
    }

    /** Remove the Include All Metrics and add all individual metrics*/
    convertIncludeAllMetricToIndividualMetrics(successCallback: () => void, failureCallback: () => void = null) {
        let self = this;
        let reportTypeName = reportTypeToString(this.reportType());
        let result = DevExpress.ui.dialog.confirm(`The ${reportTypeName} will be converted to use individual metrics. Do you confirm?`, reportTypeName);
        result.done((dialogResult) => {
            if (dialogResult) {
                self.includeAllMetrics(false);
                let mapping = MappingService.getCurrentMapping();
                let metricFields = mapping.visibleMetrics.map(x => x.createMetricOrReportField(self.isOriginalTemplate) as MetricField);

                if (self.reportType() === ReportTypeEnum.Analysis) {
                    self.fields.push(...metricFields);
                }
                else {
                    self.metricFields.push(...metricFields);
                }

                let tabOrWidget = workbook.workbookConfig.activeTabOrWidget();
                let drilldownManager = tabOrWidget.drilldownManager;
                let widget = tabOrWidget.drilldownManager.getActiveWidget();
                widget.saveSettings(function (data) {
                    self.updateReportAfterSaving(data);
                    Ir.Components.Workbook.ToolBar.ReportToolBar.repaintAnalyzeByGroupBy?.();
                    Ir.Components.ReportDesigner.ReportDesigner.reload(tabOrWidget);

                    successCallback?.();
                }, drilldownManager.activeDrilldownId);
            }
            else {
                failureCallback?.();
            }
        });
    }

    getMetricField(queryName: string): MetricField{
        let metricFields = [...this.fields().filter(x => x.isMetric), ...this.metricFields()];
        return metricFields.find(x => x.queryName === queryName) as MetricField;
    }
}